import React, { createContext, useState, useContext } from 'react';
import store from 'store';

// Create the context
const DrawerContext = createContext();

// Provide the context
export const DrawerProvider = ({ children }) => {
    const [firstTimeUserModal, setFirstTimeUserModal] = useState(false);

    const openFirstTimeUserModal = (func) => {
        if (!store.get('chapters_ftui_watched')) {
            store.set('chapters_ftui_watched', true)
            setFirstTimeUserModal(true);
            return;
        } else if (func)
            func()
    };

    const closeFirstTimeUserModal = () => {
        setFirstTimeUserModal(false);
    };

    return (
        <DrawerContext.Provider value={{ firstTimeUserModal, openFirstTimeUserModal, closeFirstTimeUserModal }}>
            {children}
        </DrawerContext.Provider>
    );
};

// Custom hook to use the DrawerContext
export const useDrawer = () => {
    const context = useContext(DrawerContext);
    if (!context) {
        throw new Error('useDrawer must be used within a DrawerProvider');
    }
    return context;
};